import { useEffect, useMemo, useState } from 'react';

import { Button } from '@/components';
import { Paginator } from '@/components/Paginator';
import NotificationItem from '@/modules/notifications/components/NotificationItem';
import {
  AppNotification,
  useNotifications,
} from '@/modules/notifications/hooks/useNotifications';

const ITEMS_PER_PAGE = 5;

export const MainContent = () => {
  const [paginatedList, setPaginatedList] = useState<AppNotification[]>([]);

  const {
    showRead,
    readCount,
    unreadCount,
    setShowRead,
    unreadNotifications,
    readNotifications,
  } = useNotifications();

  const visibleNotifications = useMemo(() => {
    if (showRead || unreadCount === 0) {
      return [...unreadNotifications, ...readNotifications];
    }

    return unreadNotifications;
  }, [showRead, unreadCount, unreadNotifications, readNotifications]);

  useEffect(() => {
    setPaginatedList(visibleNotifications.slice(0, ITEMS_PER_PAGE));
  }, [visibleNotifications]);

  const showReadButton = unreadCount > 0 && readCount > 0 && !showRead;

  const shouldPaginate = visibleNotifications.length > ITEMS_PER_PAGE;
  const itemsToRender = shouldPaginate ? paginatedList : visibleNotifications;

  return (
    <div className="flex flex-col">
      {itemsToRender.map((notification) => (
        <NotificationItem key={notification.id} notification={notification} />
      ))}

      {shouldPaginate && (
        <div className="flex justify-center mt-2">
          <Paginator
            currentContentPage={setPaginatedList}
            items={visibleNotifications}
            itemsPerPage={ITEMS_PER_PAGE}
          />
        </div>
      )}

      {showReadButton && (
        <Button
          className="text-gdt-blue text-sm font-semibold underline text-center mt-2 pb-2"
          type="button"
          variant="text"
          onClick={() => setShowRead(true)}
        >
          Ver notificaciones leídas
        </Button>
      )}
    </div>
  );
};
